import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "@/components/ui/alert-dialog";
import { cn } from "@/utils/utils";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export function CompressAlertDialog(props: {
  open: boolean;
  content: string;
  loading?: boolean;
  onClose: () => void;
}) {
  const { open, content, loading, onClose } = props;
  const { t } = useTranslation("compress-image");

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("tooltip.action-title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {loading ? (
              <div
                className={cn(
                  "flex w-full h-6 flex-col items-center justify-center"
                )}
              >
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                <p className="text-gray-600 dark:text-gray-400">
                  {t("tooltip.downloading")}
                </p>
              </div>
            ) : (
              <span>{content}</span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {/* <AlertDialogCancel>Cancel</AlertDialogCancel> */}
          <AlertDialogAction onClick={() => onClose()}>
            {t("action.close")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
